module.exports = __webpack_public_path__ + "img/section5-item1.8d974e04.svg";